
import { makeStyles } from "@material-ui/core/styles";

import { Card, Grid, Typography } from "@material-ui/core";
import componentStylesGeneric from "assets/theme/views/admin/generic";
import clsx from "clsx";
import PreviewObservations from "components/PreviewObservations";

const useStylesGeneric = makeStyles(componentStylesGeneric);

const useStylesLocal = makeStyles((theme) => ({
  cardMobilePadding: {
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2),
    },
  },
}));

export const ContractApprovalRequestObservations = ({ observations }) => {
  const classes = useStylesGeneric();
  const localClasses = useStylesLocal();
  return (
    <Grid item xs={12} md={12}>
      <Card className={clsx(classes.cardRoot, localClasses.cardMobilePadding)}>
        <Typography variant="h2" className={classes.cardTitle} color="primary">
          Observações
        </Typography>
        <Grid container>
          <PreviewObservations observations={observations?.observations} />
        </Grid>
      </Card>
    </Grid>
  );
};
